var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInvite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_84",
    "data-name": "Group 84",
    transform: "translate(-4866 -2712)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_10",
    "data-name": "Rectangle 10",
    width: 24,
    height: 24,
    transform: "translate(4866 2712)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_83",
    "data-name": "Group 83"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_82",
    "data-name": "Group 82"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M4885.555,2719.575a4.042,4.042,0,1,0-4.042,4.042A4.041,4.041,0,0,0,4885.555,2719.575Zm-6.736,0a2.695,2.695,0,1,1,2.694,2.694A2.695,2.695,0,0,1,4878.819,2719.575Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M4883.534,2725.731h-4.042a4.72,4.72,0,0,0-4.715,4.715v1.348a.674.674,0,0,0,1.347,0v-1.348a3.372,3.372,0,0,1,3.368-3.368h4.042a3.373,3.373,0,0,1,3.369,3.368v1.348a.674.674,0,0,0,1.347,0v-1.348A4.72,4.72,0,0,0,4883.534,2725.731Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M4870.822,2719.714a.674.674,0,0,0-.674.674v1.847H4868.3a.673.673,0,1,0,0,1.347h1.847v1.848a.674.674,0,0,0,1.348,0v-1.848h1.847a.673.673,0,1,0,0-1.347H4871.5v-1.847A.674.674,0,0,0,4870.822,2719.714Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInvite);
export default __webpack_public_path__ + "static/media/icon-invite.e2638cf982ab2413372b5f3535b89090.svg";
export { ForwardRef as ReactComponent };